module.exports = __webpack_public_path__ + "img/20220624105952.0f665365.png";